var _g, _g2, _g3, _g4, _g5, _g6, _g7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPartitionGraphDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 825.052,
    height: 283,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "\\u5408\\u4F53 1"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u30D1\\u30B9 3",
    d: "M8.766 0h807.52c4.841 0 8.766 3.582 8.766 8v267c0 4.418-3.925 8-8.766 8H8.766C3.924 283 0 279.418 0 275V8c.001-4.418 3.924-8 8.766-8z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u30D1\\u30B9 4",
    d: "M8.766 2C5.14 2 2.192 4.692 2.192 8v267c0 3.308 2.949 6 6.574 6h807.52c3.626 0 6.574-2.692 6.574-6V8c0-3.308-2.948-6-6.574-6H8.766m0-2h807.52c4.841 0 8.766 3.582 8.766 8v267c0 4.418-3.925 8-8.766 8H8.766C3.924 283 0 279.418 0 275V8c.001-4.418 3.924-8 8.766-8z",
    opacity: 0.5
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    "data-name": "\\u5408\\u4F53 1-2"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u30D1\\u30B9 5",
    d: "M185.501 237.5h-19V67a9.5 9.5 0 0119 0z",
    fill: "#ffe1b7"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u30D1\\u30B9 6",
    d: "M185.001 237V67a9 9 0 00-18 0v170h18m1 1h-20V67a10 10 0 0120 0z",
    fill: "#ffb54e"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 42"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\u5408\\u4F53 2"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u30D1\\u30B9 7",
    d: "M257.495 237.5h-19V103.012a9.5 9.5 0 1119 0z",
    fill: "#ffe1b7"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u30D1\\u30B9 8",
    d: "M256.995 237V103.012a9 9 0 10-18 0V237h18m1 1h-20V103.012a10 10 0 1120 0z",
    fill: "#ffb54e"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\u5408\\u4F53 3"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u30D1\\u30B9 9",
    d: "M601.501 237.5h-19v-49.388a9.5 9.5 0 1119 0z",
    fill: "#ffe1b7"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u30D1\\u30B9 10",
    d: "M601.001 237v-48.888a9 9 0 10-18 0v48.886h18m1 1h-20v-49.886a10 10 0 1120 0z",
    fill: "#ffb54e"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Partition3"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\u5408\\u4F53 3"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u30D1\\u30B9 11",
    d: "M429.501 237.5h-19V128.112a9.5 9.5 0 1119 0z",
    fill: "#ffe1b7"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u30D1\\u30B9 12",
    d: "M429.001 237V128.112a9 9 0 10-18 0v108.89h18m1 1h-20v-109.89a10 10 0 1120 0z",
    fill: "#ffb54e"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#ffb54e",
    strokeLinecap: "round",
    strokeWidth: 3,
    strokeDasharray: 6
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u30D1\\u30B9 857",
    d: "M176.295 57l71.7 36.5 172 25 172 59.649"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u30D1\\u30B9 858",
    d: "M104.001 57h72.3"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#707070",
    strokeLinecap: "round",
    strokeWidth: 2,
    strokeDasharray: 4
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u7DDA 151",
    d: "M103.999 93l143.995.5"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u7DDA 152",
    d: "M103.999 178.5h488"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u7DDA 151",
    d: "M104.752 118.496h315.244"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u7DDA 148",
    d: "M103.999 238V23"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u7DDA 147",
    d: "M103.999 238h577"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartitionGraphDown);
export default __webpack_public_path__ + "static/media/partitionGraphDown.5dd7ce158aa09771.svg";
export { ForwardRef as ReactComponent };